/* eslint-disable camelcase */
import { call, put, takeLatest } from 'redux-saga/effects';

import { ROUTES, API } from '../../utils/Apis';

import { Types } from '../redux';

// worker Saga: will be fired on SIGN_UP_ACCOUNT actions
function* signupAccount(action) {
  try {
    /**
     * Example data
     * url: enpoint/register
     
     *
     */

    const response = yield call(() =>
      API.post(ROUTES.API_REGISTER_ACCOUNT, JSON.stringify(action.userInfo))
    );

    if (response.ok) {
      const { data } = response;
      // In case: signup request success
      yield put({ type: Types.SIGN_UP_ACCOUNT_SUCCESS, data });
    } else {
      // const { msg } = response?.data?.status;
      // In case: signup request failed
      yield put({
        type: Types.SIGN_UP_ACCOUNT_FAILED,
      });
    }
  } catch (error) {
    // in case: server error
    yield put({ type: Types.SIGN_UP_ACCOUNT_FAILED, error });
  }
}

/*
  Starts signupAccount on each dispatched `SIGN_UP_ACCOUNT` action.
*/
function* signupAccountSaga() {
  yield takeLatest(Types.SIGN_UP_ACCOUNT, signupAccount);
}

export default signupAccountSaga;
